import React from "react";
export function BlockHtmlEmbed(props) {
    return props.markup ? /*#__PURE__*/ React.createElement("div", {
        className: "container-content my-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "container-content-wrapper flex justify-center",
        dangerouslySetInnerHTML: {
            __html: props.markup
        }
    })) : null;
}
